// extracted by mini-css-extract-plugin
module.exports = {"fakeHr":"Hr_fakeHr__V4FpT","right":"Hr_right__2VUnA"};